import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import { currentUserShowSuccess, fetchCurrentWorkerUserExtraDetails } from '../../ducks/user.duck';
import axios from 'axios';
import { apiBaseUrl } from '../../util/api';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';
import { TRANSITION_ZERO_REQUEST_PAYMENT } from '../../util/transaction';

const END_POINT_TO_CRM_USER_UPDATE =
  process.env.REACT_APP_CRM_WEBHOOK_UPDATE ||
  'https://services.leadconnectorhq.com/hooks/A50EzdtbbgNVTsuW3CdO/webhook-trigger/yZQl5U83Z6qMFVhn6i5u';

const sortedTransactions = txs =>
  reverse(
    sortBy(txs, tx => {
      return tx.attributes ? tx.attributes.lastTransitionedAt : null;
    })
  );
const entityRefs = entities =>
  entities.map(entity => ({
    id: entity.id,
    type: entity.type,
  }));
// ================ Action types ================ //

export const CLEAR_UPDATED_FORM = 'app/ProfileSettingsPage/CLEAR_UPDATED_FORM';

export const UPLOAD_IMAGE_REQUEST = 'app/ProfileSettingsPage/UPLOAD_IMAGE_REQUEST';
export const UPLOAD_IMAGE_SUCCESS = 'app/ProfileSettingsPage/UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_ERROR = 'app/ProfileSettingsPage/UPLOAD_IMAGE_ERROR';

export const UPDATE_PROFILE_REQUEST = 'app/ProfileSettingsPage/UPDATE_PROFILE_REQUEST';
export const UPDATE_PROFILE_SUCCESS = 'app/ProfileSettingsPage/UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_ERROR = 'app/ProfileSettingsPage/UPDATE_PROFILE_ERROR';

export const FETCH_WORKING_STAFF_REQUEST = 'app/ProfileSettingsPage/FETCH_WORKING_STAFF_REQUEST';
export const FETCH_WORKING_STAFF_SUCCESS = 'app/ProfileSettingsPage/FETCH_WORKING_STAFF_SUCCESS';
export const FETCH_WORKING_STAFF_ERROR = 'app/ProfileSettingsPage/FETCH_WORKING_STAFF_ERROR';

// export const FETCH_ALL_WORKERS_REQUEST = 'app/ProfileSettingsPage/FETCH_ALL_WORKERS_REQUEST';
// export const FETCH_ALL_WORKERS_SUCCESS = 'app/ProfileSettingsPage/FETCH_ALL_WORKERS_SUCCESS';
// export const FETCH_ALL_WORKERS_ERROR = 'app/ProfileSettingsPage/FETCH_ALL_WORKERS_ERROR';

// ================ Reducer ================ //

const initialState = {
  image: null,
  uploadImageError: null,
  uploadInProgress: false,
  updateInProgress: false,
  updateProfileError: null,
  fetchInProgress: false,
  fetchAllWorkersError: null,
  pagination: null,
  currentPageWorkers: [],
  workingStaffs: [],
  workingStaffsRequest: false,
  workingStaffsError: null,
};

export const userUpdateWebhookHelper = async data => {
  const role = data?.attributes?.profile?.publicData?.isProvider ? 'provider' : 'customer';
  const preparedData = {
    event: 'user_updated',
    role,
    data,
  };
  try {
    return axios.post(END_POINT_TO_CRM_USER_UPDATE, preparedData);
  } catch (e) {
    throw e;
  }
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case UPLOAD_IMAGE_REQUEST:
      // payload.params: { id: 'tempId', file }
      return {
        ...state,
        image: { ...payload.params },
        uploadInProgress: true,
        uploadImageError: null,
      };
    case UPLOAD_IMAGE_SUCCESS: {
      // payload: { id: 'tempId', uploadedImage }
      const { id, uploadedImage } = payload;
      const { file } = state.image || {};
      const image = { id, imageId: uploadedImage.id, file, uploadedImage };
      return { ...state, image, uploadInProgress: false };
    }
    case UPLOAD_IMAGE_ERROR: {
      // eslint-disable-next-line no-console
      return { ...state, image: null, uploadInProgress: false, uploadImageError: payload.error };
    }

    case UPDATE_PROFILE_REQUEST:
      return {
        ...state,
        updateInProgress: true,
        updateProfileError: null,
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        image: null,
        updateInProgress: false,
      };
    case UPDATE_PROFILE_ERROR:
      return {
        ...state,
        image: null,
        updateInProgress: false,
        updateProfileError: payload,
      };

    case CLEAR_UPDATED_FORM:
      return { ...state, updateProfileError: null, uploadImageError: null };

    // case FETCH_WORKING_STAFF_REQUEST:
    //   return {
    //     ...state,
    //     workingStaffsRequest: true,
    //     fetchAllWorkersError: null,
    //     currentPageWorkers: [],
    //   };
    // case FETCH_WORKING_STAFF_SUCCESS:
    //   const transactions = sortedTransactions(payload.data.data);
    //   console.log(12452,payload);
    //   return {
    //     ...state,
    //     workingStaffsRequest: false,
    //     workingStaffs: entityRefs(transactions),
    //     pagination: payload.data.meta,
    //   };
    // case FETCH_WORKING_STAFF_ERROR:
    //   console.error(payload); // eslint-disable-line
    //   return { ...state, workingStaffsRequest: false, fetchAllWorkersError: payload };

    default:
      return state;
  }
}

// ================ Selectors ================ //

// ================ Action creators ================ //

export const clearUpdatedForm = () => ({
  type: CLEAR_UPDATED_FORM,
});

// SDK method: images.upload
export const uploadImageRequest = params => ({ type: UPLOAD_IMAGE_REQUEST, payload: { params } });
export const uploadImageSuccess = result => ({ type: UPLOAD_IMAGE_SUCCESS, payload: result.data });
export const uploadImageError = error => ({
  type: UPLOAD_IMAGE_ERROR,
  payload: error,
  error: true,
});

// SDK method: sdk.currentUser.updateProfile
export const updateProfileRequest = params => ({
  type: UPDATE_PROFILE_REQUEST,
  payload: { params },
});
export const updateProfileSuccess = result => ({
  type: UPDATE_PROFILE_SUCCESS,
  payload: result.data,
});
export const updateProfileError = error => ({
  type: UPDATE_PROFILE_ERROR,
  payload: error,
  error: true,
});
//.................
// const fetchWorkingStaffRequest = () => ({ type: FETCH_WORKING_STAFF_REQUEST });
// const fetchWorkingStaffSuccess = response => {
//   return {
//     type: FETCH_WORKING_STAFF_SUCCESS,
//     payload: response,
//   };
// };
// const fetchWorkingStaffError = e => ({
//   type: FETCH_WORKING_STAFF_ERROR,
//   error: true,
//   payload: e,
// });
// ================ Thunk ================ //

// Images return imageId which we need to map with previously generated temporary id

export function uploadImage(actionPayload) {
  return (dispatch, getState, sdk) => {
    const id = actionPayload.id;
    // console.log(id, 129);
    dispatch(uploadImageRequest(actionPayload));

    const bodyParams = {
      image: actionPayload.file,
    };
    const queryParams = {
      expand: true,
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    };

    return sdk.images
      .upload(bodyParams, queryParams)
      .then(resp => {
        const uploadedImage = resp.data.data;
        dispatch(uploadImageSuccess({ data: { id, uploadedImage } }));
      })
      .catch(e => dispatch(uploadImageError({ id, error: storableError(e) })));
  };
}

export const updateProfile = actionPayload => {
  return (dispatch, getState, sdk) => {
    dispatch(updateProfileRequest());

    let apiCurrentUser = null,
      apiResponse = null;

    const queryParams = {
      expand: true,
      include: ['profileImage'],
      'fields.image': ['variants.default', 'variants.square-small', 'variants.square-small2x'],
    };

    return sdk.currentUser
      .updateProfile(actionPayload, queryParams) // webhook call attached
      .then(async response => {
        apiResponse = response;
        const entities = denormalisedResponseEntities(response);
        if (entities.length !== 1) {
          throw new Error('Expected a resource in the sdk.currentUser.updateProfile response');
        }
        const currentUser = entities[0];
        apiCurrentUser = currentUser;
        if (!apiCurrentUser.attributes.profile.protectedData.isProvider) {
          return dispatch(fetchCurrentWorkerUserExtraDetails(apiCurrentUser.id.uuid));
        }
        return null;
      })
      .then(resp => {
        if (resp !== null && typeof resp === 'object') {
          Object.assign(apiCurrentUser.attributes.profile.publicData, resp);
        }
        return userUpdateWebhookHelper(apiCurrentUser);
      })
      .then(() => {
        // Update current user in state.user.currentUser through user.duck.js
        dispatch(currentUserShowSuccess(apiCurrentUser));
        dispatch(updateProfileSuccess(apiResponse));
      })
      .catch(e => dispatch(updateProfileError(storableError(e))));
  };
};

export const customUpdateProfile = actionPayload => {
  const { dbData, profile, dbFlags } = actionPayload;
  // console.log(110011, dbData, profile);
  return (dispatch, getState, sdk) => {
    dispatch(updateProfileRequest());

    let apiCurrentUser = null,
      apiResponse = null;

    const queryParams = {
      expand: true,
      include: ['profileImage'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    };

    return (
      axios
        .post(`${apiBaseUrl()}/api/user/worker/extradetails/update`, {
          ...dbData,
          dbFlags,
        })
        .then(() => sdk.currentUser.updateProfile(profile, queryParams)) // webhook call attached
        .then(async response => {
          // console.log(111, actionPayload, response);
          apiResponse = response;
          const entities = denormalisedResponseEntities(response);
          if (entities.length !== 1) {
            throw new Error('Expected a resource in the sdk.currentUser.updateProfile response');
          }
          const currentUser = entities[0];
          apiCurrentUser = currentUser;
          if (!apiCurrentUser.attributes.profile.protectedData.isProvider) {
            return dispatch(fetchCurrentWorkerUserExtraDetails(apiCurrentUser.id.uuid));
          }
          return null;
        })
        .then(resp => {
          if (resp !== null && typeof resp === 'object') {
            Object.assign(apiCurrentUser.attributes.profile.publicData, resp);
          }
          return userUpdateWebhookHelper(apiCurrentUser);
          // Update current user in state.user.currentUser through user.duck.js
        })
        .then(() => {
          dispatch(currentUserShowSuccess(apiCurrentUser));
          dispatch(updateProfileSuccess(apiResponse));
        })
        // .then(resp => {
        //   axios.post(`${apiBaseUrl()}/api/user/worker/extradetails/update`, {
        //     ...dbData,
        //   });
        // })
        .catch(e => dispatch(updateProfileError(storableError(e))))
    );
  };
};
export const customUpdateProfileQualification = actionPayload => {
  const { dbData, profile } = actionPayload;

  // console.log(45454, dbData, profile);

  return (dispatch, getState, sdk) => {
    dispatch(updateProfileRequest());

    const queryParams = {
      expand: true,
      include: ['profileImage'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    };
    return axios
      .post(`${apiBaseUrl()}/api/user/worker/extradetails/update`, {
        ...dbData,
      })
      .then(() => {
        return sdk.currentUser.updateProfile(profile, queryParams).then(resp => {
          const dataToBeSend = denormalisedResponseEntities(resp)[0];

          return userUpdateWebhookHelper(dataToBeSend);
        });
      }) //webhook call attached
      .catch(e => dispatch(updateProfileError(storableError(e))));
  };
};

// export const fetchWorkingStaffShifts = () => async (dispatch, getState, sdk) => {
//   // console.log(111,param)
//   // const { page = 1 } = param;
//   dispatch(fetchWorkingStaffRequest());
//   // await dispatch(fetchCurrentUser());
//   // const currentUser = getState().user.currentUser;
//   // console.log(45612, page);
//   return sdk.transactions
//     .query({
//       lastTransitions: [
//         TRANSITION_ZERO_REQUEST_PAYMENT,
//         // CONFIRM_ZERO_PAYMENT
//         // REVIEW_TWO_BY_CUSTOMER,
//         // EXPIRE_CUSTOMER_REVIEW_PERIOD,
//         // REVIEW_TWO_BY_PROVIDER,
//         // EXPIRE_PROVIDER_REVIEW_PERIOD,
//         // EXPIRE_REVIEW_PERIOD,
//       ],
//       // userId: currentUser?.id?.uuid,
//       // only: 'sale',
//       include: [
//         'provider',
//         'provider.profileImage',
//         'customer',
//         'customer.profileImage',
//         'booking',
//         'listing',
//       ],
//       'fields.transaction': [
//         'lastTransition',
//         'lastTransitionedAt',
//         'transitions',
//         'payinTotal',
//         'payoutTotal',
//       ],

//       'fields.user': ['profile.displayName', 'profile.abbreviatedName', 'profile.publicData'],
//       'fields.image': ['variants.square-small', 'variants.square-small2x'],
//       page: 1,
//       per_page: 10,
//     })
//     .then(response => {
//       console.log(333, response);
//       dispatch(addMarketplaceEntities(response));
//       // // const payload = { data: finalData, meta: response.data.meta };
//       dispatch(fetchWorkingStaffSuccess(response));

//       return response;
//     })
//     .catch(e => {
//       console.log(e);
//       fetchWorkingStaffError(e);
//     });
// };
